import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover, Button, Glyphicon } from 'react-bootstrap';

import definitions from '../data/definitions';

const Definition = ({ id, type, term }) => {
    const definition = definitions[id];
    if (!definition) return null;

    const content = (
        <Popover id={id}>
            {definition}
        </Popover>
    );

    return (
        <span>
            <OverlayTrigger placement="top" trigger={['click', 'hover']} overlay={content}>
                <Button
                    bsStyle="link"
                    css={{
                        padding: '0 12px',
                        height: 20,
                        '& .glyphicon-question-sign': {
                            fontSize: 16,
                        }
                    }}
                >
                    {type === 'inline' ? term : <Glyphicon glyph="question-sign" />}
                </Button>
            </OverlayTrigger>
        </span>
    );
};

Definition.propTypes = {
    // key used to lookup defintiion
    id: PropTypes.string.isRequired,
    // inline - will be part of text
    // info - info button with no text
    type: PropTypes.oneOf(['inline', 'info'])
};

Definition.defaultProps = {
    type: 'info'
};

export default Definition;
